import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingMap from '../HarvestAndPlantingMap';
import { getCurrentSeason } from '../../../../selectors';

function HarvestMap(props) {
  return <HarvestAndPlantingMap {...props} />;
}

HarvestMap.propTypes = {
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
};

export function mapStateToProps(state, props) {
  const activeSeason = getCurrentSeason(state, props);
  const { harvestEndDate, harvestStartDate, harvestYear, cropCustomName } =
    state.seasons.list?.[activeSeason] ?? {};
  const dates = {
    endDate: harvestEndDate,
    startDate: harvestStartDate,
    year: harvestYear,
  };

  return {
    crop: cropCustomName ?? '',
    dates,
  };
}

export default connect(mapStateToProps)(HarvestMap);
